module.exports = __webpack_public_path__ + "media/images/réfrigérateur-342d81c3ab828311bbeb119df09fb9da.svg";